import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import DialogLayout from "../../../../partials/content/DialogLayout";
import Illustration from "../../../../partials/content/Illustration";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getAssetStock } from "../../../../services/finance/finance";
import AssetForm from "./assetForm/assetForm";
import { formatDate } from "../../../../utils/utils";
import { Badge } from "react-bootstrap";
import DisposalAssetForm from "./disposalAssetForm/disposalAssetForm";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
function AssetList({ history }) {
  const { reload } = useGlobalData();
  const [assets, setAssets] = useState([]);
  const [assetStockID, setAssetStockID] = useState(0);
  const [openAssetForm, setOpenAssetForm] = useState(false);
  const [openDisposalAssetForm, setOpenDisposalAssetForm] = useState(false);
  async function getAssetStockData() {
    const response = await getAssetStock();
    const { data } = response.data;
    setAssets(data.assetStocks);
  }
  useEffect(() => {
    getAssetStockData();
  }, [reload]);

  const assetDetailColumn = [
    {
      header: "Purchase Date",
      field: "purchaseDate",
      type: "date",
    },
    {
      header: "Received Date",
      field: "receivedDate",
      type: "date",
    },
    {
      header: "Asset Origin",
      field: "assetOriginTypeName",
      type: "string",
    },
    {
      header: "Vendor Name",
      field: "vendorName",
      type: "string",
    },
    {
      header: "Batch ID",
      field: "batchID",
      type: "string",
    },
    {
      header: "Asset Description",
      field: "assetDesc",
      type: "string",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];
  return (
    <React.Fragment>
      <PageSubHeader
        title="Asset List"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/assets",
            title: "Asset List",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
          {
            title: "New Asset",
            color: "primary",
            icon: "fas fa-plus-circle",
            onClick: () => {
              setAssetStockID(0);
              setOpenAssetForm(true);
            },
          },
        ]}
      />
      <ContentLayout>
        {assets.length ? (
          <CustomDataTable
            data={assets}
            dataDetailColumns={assetDetailColumn}
            onRefreshData={() => {
              getAssetStockData();
            }}
            columns={[
              {
                header: "Asset ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Item Type",
                field: "itemTypeName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.itemTypeName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Asset Code",
                field: "assetCode",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.itemType > 0 ? (
                      <span>
                        <BootstrapTooltip title={rowData.itemTypeName}>
                          <span className="mr-2">
                            <i
                              className={
                                rowData.itemType === 1
                                  ? "fas fa-boxes text-success"
                                  : rowData.itemType === 2
                                  ? "fas fa-tools text-primary"
                                  : rowData.itemType === 3
                                  ? "fas fa-building text-info"
                                  : rowData.itemType === 4
                                  ? "fas fa-boxes text-warning"
                                  : rowData.itemType === 5
                                  ? "fas fa-boxes text-danger"
                                  : null
                              }
                            ></i>
                          </span>
                        </BootstrapTooltip>
                        <span>
                          <ResponsiveEllipsis
                            text={rowData.assetCode}
                            maxLine="1"
                            displayInline
                          />
                        </span>
                      </span>
                    ) : (
                      <React.Fragment>
                        <ResponsiveEllipsis
                          text={rowData.assetCode}
                          maxLine="1"
                        />
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Asset Name",
                field: "itemName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Disposal Status",
                field: "disposalStatus",
                body: (rowData) => {
                  if (rowData.disposalStatus === 3) {
                    return (
                      <Badge variant="danger">
                        {rowData.disposalStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.disposalStatus === 2) {
                    return (
                      <Badge variant="warning">
                        {rowData.disposalStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.disposalStatus === 1) {
                    return (
                      <Badge variant="success">
                        {rowData.disposalStatusDesc}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">{rowData.disposalStatusDesc}</Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Depreciation Status",
                field: "depreciationStatus",
                body: (rowData) => {
                  if (rowData.depreciationStatus === 3) {
                    return (
                      <Badge variant="danger">
                        {rowData.depreciationStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.depreciationStatus === 2) {
                    return (
                      <Badge variant="warning">
                        {rowData.depreciationStatusDesc}
                      </Badge>
                    );
                  } else if (rowData.depreciationStatus === 1) {
                    return (
                      <Badge variant="success">
                        {rowData.depreciationStatusDesc}
                      </Badge>
                    );
                  } else {
                    return (
                      <Badge variant="dark">
                        {rowData.depreciationStatusDesc}
                      </Badge>
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Quantity",
                field: "qty",
                body: (rowData) => (
                  <div>
                    {rowData.qty} {rowData.uom.uomName}
                  </div>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Unit",
                field: "uom.uomName",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Total Asset Value",
                field: "totalValueAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.totalValueAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.disposalStatus !== 3 ? (
                      <BootstrapTooltip title="Edit Asset">
                        <button
                          type="button"
                          onClick={() => {
                            setAssetStockID(rowData.ID);
                            setOpenAssetForm(true);
                          }}
                          className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                    <BootstrapTooltip title="Asset Detail">
                      <button
                        type="button"
                        onClick={() => {
                          history.push("/finance/asset-detail/" + rowData.ID);
                        }}
                        className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                      >
                        <i className="fas fa-list-alt"></i>
                      </button>
                    </BootstrapTooltip>
                    {rowData.disposalStatus !== 3 ? (
                      <BootstrapTooltip title="Dispose Asset">
                        <button
                          type="button"
                          onClick={() => {
                            setAssetStockID(rowData.ID);
                            setOpenDisposalAssetForm(true);
                          }}
                          className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        ) : (
          <Illustration
            imageSource="INVIFO Payment.png"
            description="Hooray! You're ready to have your first Asset!"
            guidance='Hint: digitize the company assets such as "Car", "Building", "Land", etc.'
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
      <DialogLayout
        open={openDisposalAssetForm}
        title="Disposal Asset Form"
        onCloseDialog={() => {
          setOpenDisposalAssetForm(false);
        }}
        maxWIdth="lg"
      >
        <DisposalAssetForm
          assetStockID={assetStockID}
          onCloseDialog={() => {
            setOpenDisposalAssetForm(false);
          }}
          onConfirmSave={() => {
            getAssetStockData();
            setOpenDisposalAssetForm(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openAssetForm}
        title="Asset Form"
        onCloseDialog={() => {
          setOpenAssetForm(false);
        }}
        maxWIdth="lg"
      >
        <AssetForm
          assetStockID={assetStockID}
          onConfirmSave={() => {
            getAssetStockData();
            setOpenAssetForm(false);
          }}
          onCloseDialog={() => {
            setOpenAssetForm(false);
          }}
        />
      </DialogLayout>
    </React.Fragment>
  );
}

export default AssetList;
